import { render, staticRenderFns } from "./BaseFormSection.vue?vue&type=template&id=16f61a88&scoped=true&"
import script from "./BaseFormSection.vue?vue&type=script&lang=js&"
export * from "./BaseFormSection.vue?vue&type=script&lang=js&"
import style0 from "./BaseFormSection.vue?vue&type=style&index=0&id=16f61a88&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16f61a88",
  null
  
)

export default component.exports